var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PaginationController", {
        ref: "historyTable",
        attrs: {
          getDataActionName: "getUnScannedItems",
          historyLimit: _vm.limit,
          haveStartDate: _vm.isSearchWarehouseSite,
          haveNoEndDate: !_vm.isSearchWarehouseSite,
          actionPredicates: _vm.predicates
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.unscannedItems,
                    "item-key": "_key",
                    "hide-actions": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.date))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                _vm.toDateYYYYMMDDHHmm(
                                  props.item.lastModifiedTime
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.trackings.length))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.siteName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.showDetailDialog(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("details")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "beforeMenu",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs3: "", "mr-3": "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.searchTypes,
                            "item-value": "value",
                            "item-text": "name",
                            label: _vm.$t("filterBy")
                          },
                          model: {
                            value: _vm.searchType,
                            callback: function($$v) {
                              _vm.searchType = $$v
                            },
                            expression: "searchType"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs3: "", "mr-3": "" } },
                      [
                        _vm.isSearchWarehouseSite
                          ? _c("v-autocomplete", {
                              attrs: {
                                items: _vm.warehousesSites,
                                "item-value": "key",
                                "item-text": "siteName",
                                label: _vm.$t("warehouseSite")
                              },
                              model: {
                                value: _vm.warehouseSite,
                                callback: function($$v) {
                                  _vm.warehouseSite = $$v
                                },
                                expression: "warehouseSite"
                              }
                            })
                          : _c("v-text-field", {
                              attrs: { label: _vm.$t("searchByTracking") },
                              model: {
                                value: _vm.tracking,
                                callback: function($$v) {
                                  _vm.tracking = $$v
                                },
                                expression: "tracking"
                              }
                            })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.unscannedItems,
          callback: function($$v) {
            _vm.unscannedItems = $$v
          },
          expression: "unscannedItems"
        }
      }),
      _vm._v(" "),
      _vm.dialog.show
        ? _c("UnScannedDetailPopup", {
            attrs: { item: _vm.dialog.data },
            model: {
              value: _vm.dialog.show,
              callback: function($$v) {
                _vm.$set(_vm.dialog, "show", $$v)
              },
              expression: "dialog.show"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ec702e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ec702e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnScannedTab.vue
// module id = null
// module chunks = 